import moment from 'moment'

import PatientDetails from 'components/reports/PatientDetails'
import DoctorDetails from 'components/reports/DoctorDetails'
import SocialHistory from 'components/reports/SocialHistory'
import AlcoholDetails from './AlcoholDetails'
import Medications from 'components/reports/Medications'
import ClinicalExaminations from 'components/reports/ClinicalExamination'
import Attachments from 'components/reports/Attachments'

function Alcohol({ data }) {

    if (!data) return null

    return (
        <div>
            <h2>{data.request.formName}</h2>
            <hr />
            <p>Report generated: {moment().format('DD/MM/yyyy')}</p>
            <p>Insurer: {data.request.insurer.name}</p>
            <p>Policy No: {data.request.primaryReferenceNumber}</p>
            <hr />
            <PatientDetails data={data} />
            <hr />
            <DoctorDetails data={data} />
            <hr />
            <h3>Recent Summary</h3>
            <br />
            <SocialHistory data={data} />
            <br />
            <ClinicalExaminations exam={data.conditionSpecific.mostRecentSummary.clinicalExamination} />
            <br />
            <Medications data={data} />
            <hr />
            <AlcoholDetails data={data} />
            <hr />
            <Attachments data={data} />
        </div>
    )
}

export default Alcohol
